const ALTERNATE_API = `https://logo.clearbit.com`; // https://blog.clearbit.com/logo/

const getSportData = (sportName) => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/?sport=${sportName}`;
  return fetch(url)
    .then((res) => res.json())
    .then((obj) => extendWithImages(obj.Games));
};

export default getSportData;

function extendWithImages(games) {
  return Promise.all(
    games
      .filter((game) => game.AwayTeamDetail && game.HomeTeamDetail)
      .map(async (game) => ({
        ...game,
        AwayTeamDetail: {
          ...game.AwayTeamDetail,
          WikipediaLogoUrl: await getLogoUrl(
            game.AwayTeamDetail.TeamLogoUrl ||
              game.AwayTeamDetail.WikipediaLogoUrl,
            game.AwayTeamName ||
              game.AwayTeamDetail.FullName ||
              game.AwayTeamDetail.Name ||
              game.AwayTeamDetail.School,
            game.AwayTeamDetail.Website
          ),
        },
        HomeTeamDetail: {
          ...game.HomeTeamDetail,
          WikipediaLogoUrl: await getLogoUrl(
            game.HomeTeamDetail.TeamLogoUrl ||
              game.HomeTeamDetail.WikipediaLogoUrl,
            game.HomeTeamName ||
              game.HomeTeamDetail.FullName ||
              game.HomeTeamDetail.Name ||
              game.HomeTeamDetail.School,
            game.HomeTeamDetail.Website
          ),
        },
      }))
  );
}

function getLogoUrl(url, name, domain) {
  const extractedName = name
    .split(/[ _]/g)
    .filter((part) => part.length > 3)
    .join(" ");
  const extractedDomain =
    (domain && domain.replace(/http(s)?:\/\/(www\.)?/, "")) || extractedName;

  return new Promise((resolve) => {
    if (url) {
      const config = {
        mode: /amazonaws|optasports/.test(url) ? "no-cors" : "cors",
      };
      fetch(url, config)
        .then((res) => {
          if (res.status === 404) {
            resolve(`${ALTERNATE_API}/${extractedDomain}` || "");
          } else {
            resolve(url);
          }
        })
        .catch((err) => {
          resolve(`${ALTERNATE_API}/${extractedDomain}` || "");
        });
    } else {
      resolve(`${ALTERNATE_API}/${extractedDomain}` || "");
    }
  });
}
